module.exports = __webpack_public_path__ + "static/media/GoldMedalIcon.fa9c2e08.svg";